import { IImportModel } from '../importer/model';

export const ancillaryActivitiesImportDomainSelector = (state: any): IImportModel =>
  state.ancillaryActivitiesImport as IImportModel;
